<template>
    <div
        class="inline-block relative"
        @mouseover="mouseOverHandler"
        @mouseleave="mouseLeaveHandler"
    >
        <div class="inline-block cursor-pointer"
             :class="{'pc-green-nav' : $page.component.startsWith('Projects') }"
             @click="expanded = !expanded"
        >
            Portfólio
        </div>
        <div v-if="expanded" class="dropdown-items nav-bg absolute">
            <Link
                v-for="project in projects"
                :key="project.path"
                :href="route(project.path)"
                class="w-full"
                :class="{'pc-green-text' : $page.component === `Projects/${project.path}`}"
            >
                {{project.name}}
            </Link>
        </div>
    </div>
    <!-- </div> -->
</template>

<script setup>
import { ref } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';

const expanded = ref(false);
const projects = ref([
    {
        name: 'Gestão de Projetos',
        path: 'SGP4'
    },
    {
        name: 'Chamadas Públicas',
        path: 'ChamadaPublica'
    },
    {
        name: 'Calculadora de Carbono',
        path: 'PegadaDeCarbono'
    },
    {
        name: 'Simulador de Consumo',
        path: 'SimuladorDeConsumo'
    },
    {
        name: 'Gestão de Reuniões',
        path: 'ReunaMe'
    },
    // {
    //     name:'Sistema de Horas-extras',
    //     path:'horas-extras'
    // },
    // {
    //     name:'Plataforma de Ensino Médio',
    //     path:'nitro'
    // },
]);

const _timerId = ref();

const mouseLeaveHandler = () => {
    clearTimeout(_timerId.value)
    _timerId.value = setTimeout(() => {
        expanded.value = false
    }, 200)
};

const mouseOverHandler = () => {
    clearTimeout(_timerId.value)
    expanded.value = true
};
/*
export default {
    data(){
        return {
            expanded:false,
            projects:[
                {
                    name:'Gestão de Projetos',
                    path:'SGP4'
                },
                {
                    name:'Chamadas Públicas',
                    path:'ChamadaPublica'
                },
                {
                    name:'Calculadora de Carbono',
                    path:'PegadaDeCarbono'
                },
                {
                    name:'Simulador de Consumo',
                    path:'SimuladorDeConsumo'
                },
                {
                    name:'Gestão de Reuniões',
                    path:'Reuna.me'
                },
                // {
                //     name:'Sistema de Horas-extras',
                //     path:'horas-extras'
                // },
                // {
                //     name:'Plataforma de Ensino Médio',
                //     path:'nitro'
                // },
            ]
        }
    },
    computed:{
        currentRoutePath(){
          return this.$nuxt.$route.path;
        },
        currentRouteName(){
          const currentRoute = this.$nuxt.$route;
          return currentRoute.name.split('-')[1];
        },
        isCurrentlyInProjects(){
          const projectsPath = '/projetos'
          return this.currentRoutePath.slice(0, projectsPath.length) === projectsPath;
        },
    },
    methods:{
        mouseLeaveHandler(){
            clearTimeout(this._timerId)
            this._timerId =  setTimeout(() => {
                this.expanded = false
            }, 200)
        },
        mouseOverHandler(){
            clearTimeout(this._timerId)
                this.expanded = true

        },
    },
}
*/
</script>

<style lang="postcss" scoped>
.nav-bg {
    opacity: 0.8;
}

.dropdown-items {
    min-width: 300px;
    top:42px;
    left: -100px;
    border-radius: 0 0 10px 10px;
    z-index: 10;

    & > :not(:last-child) {
        border-bottom: 1px solid #FFFF;
    }

    & > * {
        @apply py-3 w-full flex justify-center;
    }

    @apply flex flex-col justify-between items-center px-5;
}
</style>
